<div class="chat-message chat-message-user" *ngIf="message.sender === 'user'">
  <div class="chat-user-message">
    {{ message.text }}
  </div>
</div>

<div class="chat-message chat-message-assistant" *ngIf="message.sender === 'assistant'">
  <lib-chat-response-message [responseGroup]="message.responseGroup">
  </lib-chat-response-message>
</div>
